import { useCallback, useEffect, useState } from "react"
import { isStorageAvailable } from "../services/Storage";

export function WebStorageAlert() {

    const [isOpen, setIsOpen] = useState(false);
    const [isShowDetails, setIsShowDetails] = useState(false);

    const handleOpenDetail = useCallback(() => {
        setIsShowDetails(true);
    }, []);

    const handleClose = useCallback(() => {
        setIsOpen(false);
    }, []);

    useEffect(() => {
        if (isStorageAvailable('localStorage')) {
            console.log("localStorage is available.")
            setIsOpen(false);
        } else {
            console.warn("localStorage is Not available.")
            setIsOpen(true);
        }
    }, []);

    if (!isOpen) {
        return null;
    }

    return <div className='alert alert-warning d-flex align-items-center py-1'>
        <svg className='bi flex-shrink-0 me-2' fill="currentColor" width="24" height="24" viewBox="0 0 16 16">
            <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
        </svg>

        <div className="flex-grow-1">
            <small>このデッキはページを移動すると削除されます。</small>
            <button className='btn btn-sm btn-link p-0' onClick={handleOpenDetail}>詳細</button>
            {
                isShowDetails ? <p className="mb-0">
                    <small>お使いのブラウザでデータの保存が許可されていません。データを保存するには、「ウェブストレージ」機能を有効にしてください。</small>
                </p> : null
            }
        </div>

        <button type="button" className="btn-close" aria-label="Close" onClick={handleClose}></button>
    </div>
}
